﻿import $ from "jQuery";
import motivUi from "motivUi";
import onPageUpdated from "./_on-page-updated";
import { copyTextWithConfirmation } from "./_utils";

motivUi.setup
    .validation()
    .loadingSpinner('button[type="submit"]', 'disabled', 'disabled--current')
    .eventTracking();

$(function () {
    onPageUpdated();
    sessionTimeout();
    $('main').fadeTo(800, 1);
});

function sessionTimeout() {
    setTimeout(function () {
        if (window.location.pathname.toLowerCase() != motivUi.globals.routing.pathBase.toLowerCase() + "/timeout"
            && document.cookie.indexOf("SessionTimeout") == -1) {
            motivUi.addEvent('SessionTimeout', 'Redirect');
            window.open(motivUi.globals.routing.pathBase + "/timeout", "_self");
        } else {
            sessionTimeout();
        }
    }, 5000);
};

$(".fa-copy").on("click", function () {
    copyTextWithConfirmation(this);
});